export default {"src":"/_next/static/media/Home-white.fe02b490.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};